module.exports = __webpack_public_path__ + "img/warn-icon.cb216399.svg";